import { useSharedState } from "./useSharedState";

export function useIOSCheck() {
  const { isIOS } = useSharedState();

  return isIOS;
}
